import * as React from "react";
import ActionDropdown from "./ActionsDropdown";
import { Patient } from "../../patient/types";
import { Appointment, AppointmentStatus } from "../types";
import moment from "moment";

interface StoreProps {
  showMessages: boolean;
  appointments: Appointment[];
}

interface DispatchProps {
  updateStatus: (state: AppointmentStatus) => void;
  toggleMessageFamily: () => void;
}

interface OwnState {
  submitDisabled: boolean;
  patient: Patient | null;
}

type Props = StoreProps & DispatchProps;

class Appointments extends React.PureComponent<Props, OwnState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true,
      patient: null
    };
  }

  render() {
    const { appointments } = this.props;
    return (
      <div className="section p-15">
        <h1>Central Health Appointments</h1>

        <div className="flex list-header mb-10 mt-20">
          <div className="flex-1">Patient</div>
          <div className="flex-1">Time</div>
          <div className="flex-2">Status</div>
          <div className="action-column">Actions</div>
        </div>

        {appointments.map((apt, index) => (
          <div
            key={index}
            className={"flex entry " + (apt.status == AppointmentStatus.cancelled && "cancelled")}
          >
            <div className="flex-1">{apt.name}</div>
            <div className="flex-1">{moment(apt.time).format("hh:mm a")}</div>
            <div className="flex-2">
              <div
                className={
                  [
                    AppointmentStatus.waiting,
                    AppointmentStatus.entrance_request,
                    AppointmentStatus.in_treatment
                  ].includes(apt.status)
                    ? "bold"
                    : ""
                }
              >
                {apt.status}
              </div>
              {apt.status === AppointmentStatus.waiting && (
                <div className="flex-justify-center mt-10">
                  <div
                    className="message-button"
                    onClick={() => this.props.updateStatus(AppointmentStatus.entrance_request)}
                    role="button"
                    tabIndex={0}
                  >
                    <i className="far fa-comment-alt"></i>Please Come In
                  </div>
                </div>
              )}
              {apt.status === AppointmentStatus.entrance_request && (
                <div
                  className="flex-justify-center mt-10"
                  onClick={() => this.props.updateStatus(AppointmentStatus.in_treatment)}
                  role="button"
                  tabIndex={0}
                >
                  <div className="message-button">
                    <i className="far fa-clinic-medical"></i>In Treatment
                  </div>
                </div>
              )}
              {apt.status === AppointmentStatus.in_treatment && (
                <div className="flex-justify-center mt-10">
                  <div
                    className="message-button mr-20"
                    onClick={() => this.props.toggleMessageFamily()}
                    role="button"
                    tabIndex={0}
                  >
                    <i className="far fa-comment-alt"></i>Update Family
                  </div>
                  <div
                    className="message-button"
                    onClick={() => this.props.updateStatus(AppointmentStatus.complete)}
                    role="button"
                    tabIndex={0}
                  >
                    <i className="fas fa-check"></i>Visit Complete
                  </div>
                </div>
              )}
            </div>
            <div className="action-column">
              <ActionDropdown patient={this.state.patient} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default Appointments;
